<ng-container>
  <div class="d-none d-md-block" >
    <div class="page-container" #pagelist>
      @for (pageSize of pageSizes; track pageSize; let pId = $index) {
        <div class="page-image">
          @if (!isPagePreloaded(pId+1)) {
            <canvas [style.aspectRatio]="aspectRatio(pageSize.X,pageSize.Y)" style="width:100%; background-color: white;" id="{{pId+1}}_indicator"></canvas>
          }
          @if (isPagePreloaded(pId+1)) {
            <img [style.aspectRatio]="aspectRatio(pageSize.X,pageSize.Y)" style="width:100%"  [src]="getPageUrl(pId+1)" id="{{pId+1}}_indicator" alt="Page{{pId+1}}" class="page-image">
          }
        </div>
      }

      @for (signatureField of signaturefields; track signatureField; let i = $index) {
        @if (displayfields && signatureField.readonly) {
          <div class="grid grid-start" [ngClass]="{'signatureField':true,'readonly':signatureField.readonly}"
            [ngStyle]="{'position': 'absolute','top' : signatureField.y+'px', 'left': signatureField.x+'px'}"
            id="{{signatureField.name}}">
            <div class="child disabled">
              <div class="placeholder-field disabled" [style.width.px]="signatureField.width" [style.height.px]="signatureField.height">
                @if (signatureField.width < 140) {
                  <span class="ms-3">{{signatureField.acronym}}</span>
                }
                @if (signatureField.width >= 140) {
                  <span class="ms-3">{{signatureField.fullname}}</span>
                }
              </div>
            </div>
          </div>
        }
      }
    </div>

    <div class="panzoom-div" style="z-index:9999;">
      <div cdkDropListGroup class="panzoom-listgroup" id="panzoomList" [style.marginTop.px]="-TOP_MARGIN" [style.marginBottom.px]="TOP_MARGIN">
        @for (signatureField of signaturefields; track signatureField; let i = $index) {
          @if (displayfields && !signatureField.readonly) {
            <div class="grid grid-start active pointer-events-auto user-select-none {{signatureField.name}}"
              ngDraggable
              (stopped)="draggingStopped($event, signatureField.actorId)"
              [ngClass]="{'signatureField':true, 'animated':true,'zoomInRight':true,'readonly':signatureField.readonly}"
              [position]="{'y': signatureField.y, 'x': signatureField.x}"
              [ngStyle]="{'position': 'absolute'}"
              [bounds]="pagelist"
              [inBounds]="true"
              (movingOffset)="onSignatureMoving()"
              id="activePlaceholderField"
              [style.width.px]="signatureField.width"
              [style.height.px]="signatureField.height"
              [handle]="dragHandle"
              #signature>
              @if (isDraggable) {
                <div id="gridlineHorizontalTop"></div>
              }
              @if (isDraggable) {
                <div id="gridlineVerticalLeft"></div>
              }
              <div class="placeholder-field child active draggableSignatureField"
                id="{{signatureField.name}}"
                ngResizable
                (rzResizing)="onSignatureResizing($event)"
                (rzStop)="signatureResized($event, signatureField.actorId)"
                [rzAspectRatio]="true"
                [rzMinWidth]="90"
                rzHandles="se"
                [style.width.px]="signatureField.width"
                [style.height.px]="signatureField.height"
                #dragHandle>
                <i class="bi bi-grip-vertical grip-placeholder-field" aria-hidden="true"></i>
                @if (resizableSignatureWidth < 140) {
                  <span>{{signatureField.acronym}}</span>
                }
                @if (resizableSignatureWidth >= 140) {
                  <span>{{signatureField.fullname}}</span>
                }
              </div>
              @if (showDropdown && signatureProviders.length > 0) {
                <div class="no-drag dropdown" style="margin-top:70px !important;" [style.margin-top.px]="!displayDropDownBelow ? -HEIGHT_OF_SIGNATUREPROVIDER_DROPDOWN : (marginTopDropdownQTSP + 4)" [style.width.px]="widthDropdownQTSP">
                  <a class="form-control d-flex subheader align-items-center justify-content-between w-100" data-bs-toggle="dropdown" aria-expanded="false" (click)="$event.stopPropagation();">
                    <span class="text-truncate flex-grow-1 me-2">{{getSelectedSignatureProviders()}}</span>
                    <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                  </a>
                  <div class="dropdown d-flex" id="dropdownFilterMenu" (change)="applySignatureProvidersSelection($event)">
                    <ul class="dropdown-menu dashboard-filter-dropdown">
                      <li class="option-item-small description" translate="Request.PreparationDialog.AllowedSignatureProviders"></li>
                      @for (signatureProvider of signatureProviders; track signatureProvider; let i = $index) {
                        <li class="option-item-small">
                          <input type="checkbox" class="checkbox form-check-input" name="signatureProvider_{{signatureProvider.name}}" [id]="getProviderValue(signatureProvider)" [value]="getProviderValue(signatureProvider)" [checked]="checkIfProviderIsSelected(signatureProvider)"
                            [disabled]="disableSignatureProviders || isDisabled(signatureProvider)">
                            <label class="form-check-label" [for]="getProviderValue(signatureProvider)" (click)="$event.stopPropagation();"> {{ signatureProvider.name }}</label>
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
                @if (isDraggable) {
                  <div id="gridlineHorizontalBottom"></div>
                }
                @if (isDraggable) {
                  <div id="gridlineVerticalRight"></div>
                }
              </div>
            }
          }
        </div>
      </div>

      <!-- navigation bar-->
      <div class="modal-footer custom d-flex justify-content-center modal-footer--sticky">
        <button type="button" class="btn btn-sm btn-outline-primary btn-shadow me-2" (click)="close()" translate="Button.Back"></button>
        <div class="btn-group btn-sm btn-shadow me-2">
          <button type="button" [disabled]="pageId===1" class="btn btn-sm pdf-preparation-dialog-buttons-border text-primary" (click)="scrollToPage(pageId-1);"><em class="bi bi-caret-left-fill"></em></button>
          <div class="btn-group btn-sm" ngbDropdown placement='top-start' role="group" aria-label="Button group with nested dropdown" [ngClass]="{'pagination-setplaceholder-wider': !place}">
            <button type="button" class="btn btn-sm btn-primary" ngbDropdownToggle>{{pageId}}/{{pageSizes.length}}</button>
            <div class="dropdown-menu dropdown-menu-pdf-preparation-dialog"  ngbDropdownMenu>
              @for (page of [].constructor(pageSizes.length); track $index; let pId = $index) {
                <button ngbDropdownItem (click)="scrollToPage(pId+1);" class="btn-sm">{{pId+1}}</button>
              }
            </div>
          </div>
          <button type="button" [disabled]="pageId===pageSizes.length" class="btn btn-sm pdf-preparation-dialog-buttons-border text-primary" (click)="scrollToPage(pageId+1);"><em class="bi bi-caret-right-fill"></em></button>
        </div>
        <div class="btn-group btn-sm btn-shadow me-2">
          <button type="button" [disabled]="currentZoomLevel==0" class="btn btn-sm pdf-preparation-dialog-buttons-border text-primary" (click)="zoomOut()"><em class="bi bi-zoom-out"></em></button>
          <button type="button" [disabled]="currentZoomLevel==zoomLevels.length-1" class="btn btn-sm pdf-preparation-dialog-buttons-border text-primary" (click)="zoomIn()"><em class="bi bi-zoom-in"></em></button>
        </div>
        @if (isRequestInBuildStatus) {
          @if (place && allowedMultipleSignaturefields) {
            <button type="button" class="btn btn-sm btn-success btn-shadow pdf-preparation-dialog-buttons" (click)="saveSignatureField(true)" [disabled]="selectedSignatureProviders.length === 0" translate="Button.PlacePlusOne"></button>
          }
          @if (place && !setMoreSignaturefields) {
            <button type="button" class="btn btn-sm btn-success btn-shadow pdf-preparation-dialog-buttons" (click)="saveSignatureField()" [disabled]="selectedSignatureProviders.length === 0" translate="Button.Place" data-testid="placeButton"></button>
          }
          @if (place && setMoreSignaturefields) {
            <button type="button" class="btn btn-sm btn-primary btn-shadow pdf-preparation-dialog-buttons" (click)="saveSignatureField()" [disabled]="selectedSignatureProviders.length === 0" translate="Button.Next" data-testid="nextButton"></button>
          }
          @if (!place && showEditDocument) {
            <button type="button" class="btn btn-sm btn-secondary btn-shadow pdf-preparation-dialog-buttons" (click)="editDocument()" translate="Button.Edit"></button>
          }
        }
      </div>
      <!-- end navigation bar -->

    </div>
  </ng-container>